module.exports = __webpack_public_path__ + "static/media/riparte.514bd304.png";